import { alpha } from '@mui/material/styles'

import { muiTheme } from 'mui-theme'

// Figma exports these as 0.88%, 23.66% and 99.61%; rounded, the difference isn't visible
const BRAND_GRADIENT_STOPS = { mint: 0, dodgerBlue: 24, heliotrope: 100 }

export function getBrandGradient(angleDeg: number, opacity = 1) {
  const {
    marketingGreenMintDark,
    marketingBlueDodgerBlueDark,
    marketingPurpleHeliotropeDark
  } = muiTheme.palette
  const { mint, dodgerBlue, heliotrope } = BRAND_GRADIENT_STOPS

  return `linear-gradient(${angleDeg}deg, ${alpha(
    marketingGreenMintDark.main,
    opacity
  )} ${mint}%, ${alpha(
    marketingBlueDodgerBlueDark.main,
    opacity
  )} ${dodgerBlue}%, ${alpha(
    marketingPurpleHeliotropeDark.main,
    opacity
  )} ${heliotrope}%)`
}
